import { Motion, spring } from 'react-motion'

import toFullscreenAnimationStyles from './ToFullscreenAnimation.css'
import { MOTION_PRESETS } from '/react/constants/motionPresets'

import { withViewport } from '/react/utils/withViewport'

@withViewport()

export class ToFullscreenAnimationZoom extends React.PureComponent {
  springConfig = MOTION_PRESETS.FAST

  render () {
    const {
      animationFrameTarget,
      children,
      handleToFullscreenAnimationEnd,
      isToFullscreenAnimationDone,
      viewportHeight,
      viewportWidth
    } = this.props

    if (isToFullscreenAnimationDone) return null

    const animationFrameTargetSizeAndPosition = animationFrameTarget.getBoundingClientRect()

    return (
      <Motion
        defaultStyle={{
          height: animationFrameTargetSizeAndPosition.height,
          left: animationFrameTargetSizeAndPosition.left,
          opacity: 0,
          top: animationFrameTargetSizeAndPosition.top,
          width: animationFrameTargetSizeAndPosition.width
        }}
        style={{
          height: spring(viewportHeight, this.springConfig),
          left: spring(0, this.springConfig),
          opacity: spring(1, this.springConfig),
          top: spring(0, this.springConfig),
          width: spring(viewportWidth, this.springConfig)
        }}
        onRest={handleToFullscreenAnimationEnd}
      >
        {(interpolatedStyle) => (
          <div
            className={toFullscreenAnimationStyles.animationFrame}
            style={{
              height: interpolatedStyle.height,
              opacity: interpolatedStyle.opacity,
              transform: `translate3d(${interpolatedStyle.left}px, ${interpolatedStyle.top}px, 0)`,
              width: interpolatedStyle.width
            }}
          >
            {children}
          </div>
        )}
      </Motion>
    )
  }
}
